module.exports = __webpack_public_path__ + "static/media/aqi.9cdf2492.svg";